import React from "react";
import { useModal } from "@clayui/modal";
import Loading from "../../../common/components/Loading";
import AlertModal from "../../../common/components/AlertModal";
import FormsGeneric from "../FormsGeneric";
import classNames from "classnames";
import { getPageLayoutType, getSignedIdStatus, urlParams } from "../../../common/utils/utilsFunc";
import IngressoRectAndSolicitContextProvider, {
  ACTIONS,
  IngressoRectAndSolicitContext,
} from "../context/IngressoRecAndSolicitContextProvider";
import { CGE } from "../../../common/components/CGE";

const DUPLICATE_CLAIM_RESPONSE_CODE = 2;

const IngressoReclamoController = ({
  props,
  codigo_empresa,
  textFetchError,
  url,
  CTI,
  solicitud,
  tituloSolicitud,
  msgVerification,
  msgCost
}) => {
  const [loading, setLoading] = React.useState(false);
  const [inputIdClient, setInputIdClient] = React.useState();
  const [jsonForm, setJsonForm] = React.useState(null);
  const [state, dispatch] = React.useContext(IngressoRectAndSolicitContext);
  const [error, setError] = React.useState("")
  const [visibleModalError, setVisibleModalError] = React.useState(false);
  const [visibleModalConfirm, setVisibleModalConfirm] = React.useState(false);
  const [visibleModalCost, setVisibleModalCost] = React.useState(false);
  const [handleSecondModal, setHandleSecondModal] = React.useState(false);
  const [msgModalConfirm, setMsgModalConfirm] = React.useState(null);
  const [msgModalCost, setMsgModalCost] = React.useState(null);
  const [detailClient, setDetailClient] = React.useState([]);
  const [valueExist, setValueExist] = React.useState();
  const [optionsInteraction, setOptionsInteraction] = React.useState([
    {
      label: "[Seleccione una opción]",
      value: "0",
    }
  ]);
  const [confirm, setConfirm] = React.useState(false);
  const { observer, onClose } = useModal({
    onClose: () => {
      setVisibleModalError(false);
      setVisibleModalConfirm(false);
      setVisibleModalCost(false);
    }
  });

  let allComunas = [];
  allComunas = [
    {
      label: "[Seleccione Comuna]",
      value: 0,
    },
  ];

  if (state.allComuna?.code === 0) {
    let dataAllComunas = state.allComuna?.comunas;
    dataAllComunas?.forEach((item) => {
      allComunas.push({ label: item.nomComuna, value: item.codigoSAP });
    });
  }

  React.useEffect(() => {
    if(state.userAttributes && state.allComuna){
      // eslint-disable-next-line no-undef
      Liferay.Service(
        '/user/get-user-by-email-address',
        {
          // eslint-disable-next-line no-undef
          companyId: Liferay.ThemeDisplay.getCompanyId(),
          // eslint-disable-next-line no-undef
          emailAddress: Liferay.ThemeDisplay.getUserEmailAddress()
        },
        function(obj) {
          setValueExist({
            rut : obj.screenName,
            nombre: state.userAttributes.given_name,
            apelidoParterno: state.userAttributes.family_name,
            apelidoMaterno: state.userAttributes["custom:second_family_name"],
            comuna: state.userAttributes["custom:address_commune"],
            calle: state.userAttributes["custom:address_street"],
            num: state.userAttributes["custom:address_number"],
            blockDpto: state.userAttributes["custom:address_building"],
            email: state.userAttributes["email"],
            telefono: state.userAttributes["custom:house_phone_number"]
          })
        }
      );
    }
  },[state.userAttributes]);

  React.useEffect(() => {
    if (solicitud) {
      setLoading(true);
      dispatch({
        payload: true,
        type: ACTIONS.SET_LOAD_PAGE,
      });
      dispatch({
        payload: "SO",
        type: ACTIONS.SET_TAG_CURRENT_INTERACTION,
      });
    }
  }, [solicitud]);

  React.useEffect(() => {
    if (getPageLayoutType()) {
      setLoading(true);
      dispatch({
        payload: true,
        type: ACTIONS.SET_LOAD_PAGE,
      });
      dispatch({
        payload: "SO",
        type: ACTIONS.SET_TAG_CURRENT_INTERACTION,
      });
    }
  }, [])

  React.useEffect(() => {
    if (state.listInteraction?.code === 0) {
      let options = []
      let data = state.listInteraction?.tipoSolicitud;
      data.forEach((item) => {
        options.push({ label: item.nombre, value: item.codigo })
      });
      if (options.length > 0) {
        setOptionsInteraction([...optionsInteraction, ...options]);
        setLoading(false);
      }
    }
  }, [state.listInteraction]);

  React.useEffect(() => {
    //publica
    if (CTI && optionsInteraction.length > 1 && solicitud && !getPageLayoutType()) {
      let labelOption = null
      optionsInteraction.forEach(item => {
        if (item.value === CTI) {
          labelOption = item.label
        }
      })
      if (labelOption) {
        setOptionsInteraction([{ label: labelOption, value: CTI }])
      }
      dispatch({
        payload: CTI,
        type: ACTIONS.SET_CTI,
      });
    }
    //privado
    const CTIPriv = urlParams.get('cti')
    if (CTIPriv && getPageLayoutType() && optionsInteraction.length > 1) {
      let labelOption = null
      optionsInteraction.forEach(item => {
        if (item.value === CTIPriv) {
          labelOption = item.label
        }
      })
      if (labelOption) {
        setOptionsInteraction([{ label: labelOption, value: CTIPriv }])
      }
      dispatch({
        payload: CTIPriv,
        type: ACTIONS.SET_CTI,
      });
    }
  }, [optionsInteraction])

  React.useEffect(() => {
    setLoading(false);
  }, [state.listInteraction])
  React.useEffect(() => {
    if (state.comuna && state.idList) {
      setLoading(false);
    }
  }, [state.comuna && state.idList]);

  React.useEffect(() => {
    if (inputIdClient) {
      setLoading(true);
    }
    dispatch({
      payload: inputIdClient,
      type: ACTIONS.SET_IDCLIENT,
    });
  }, [inputIdClient]);

  React.useEffect(() => {
    const detailClient = state.detailClient?.ConsultarDetalleCtaCtoResponse
    if (state.detailClient) {
      setInputIdClient("");
      if(detailClient?.RETORNO?.RETURN === 0  && detailClient?.ITEM?.SOCIEDAD === codigo_empresa) {
        setDetailClient(detailClient?.ITEM)
        setVisibleModalError(false);
        setError(null)
      } else if (detailClient?.RETORNO?.RETURN !== 0 || state.detailClient?.status || detailClient?.ITEM?.SOCIEDAD !== codigo_empresa) {
        setVisibleModalError(true);
        setDetailClient([])
        setError(detailClient?.RETORNO?.TEXTO_RETURN ? detailClient?.RETORNO?.TEXTO_RETURN : textFetchError)
        setInputIdClient("");
      }
    }
    if (state.detailClient) {
      setLoading(false);
    }
  }, [state.detailClient]);

  React.useEffect(() => {
    if (jsonForm) {
      dispatch({
        payload: jsonForm,
        type: ACTIONS.SET_CONFIRM_FORMCONT,
      });
      setJsonForm(null)
    }
  }, [jsonForm]);

  React.useEffect(() => {
    if (state.valueCost) {
      setLoading(false);
      setVisibleModalCost(true);
      if (state.valueCost.code === 0) {
        setVisibleModalError(false);
        setMsgModalCost(`${msgCost} ${state.valueCost.precio}. ¿Desea Continuar?`);
      } else if (state.valueCost.code !== 0 && state.valueCost.message) {
        setVisibleModalError(true);
        setError(state.valueCost.message)
      } else {
        setVisibleModalError(true);
        setError(textFetchError)
      }
    }
  }, [state.valueCost])

  React.useEffect(() => {
    let objFiltered = state.listInteraction?.tipoSolicitud?.filter(obj => obj.codigo === state.confirmFormsCont?.CdgTipoReclamo);
    if (state.confirmFormsCont) {
      if (state.confirmFormsCont?.CdgTipoReclamo === "ZC0000070040") {
        setHandleSecondModal(true)
        setVisibleModalConfirm(true);
        setMsgModalConfirm(msgVerification)
        if (objFiltered?.length === 1 && objFiltered[0]?.implicaCobro) {
          setLoading(true);
          dispatch({
            payload: objFiltered[0]?.codigo,
            type: ACTIONS.SET_CODIGO_INTERACION_TO_COST,
          });
        } else {
          setHandleSecondModal(false)
        }
      }
      else if (state.confirmFormsCont?.CdgTipoReclamo !== "ZC0000070040" && objFiltered?.length === 1 && objFiltered[0]?.implicaCobro) {
        setLoading(true);
        dispatch({
          payload: objFiltered[0]?.codigo,
          type: ACTIONS.SET_CODIGO_INTERACION_TO_COST,
        });
      } else {
        setLoading(true);
        setHandleSecondModal(false)
        let jsonReclamo = {
          apellido1: state.confirmFormsCont.lastName,
          apellido2: state.confirmFormsCont.motherLastName,
          calle: state.confirmFormsCont.CalleReclamante,
          calleServicio: detailClient?.CALLE,
          canal: getPageLayoutType() ? "ZOV" : "URL",
          comuna: state.confirmFormsCont.ComunaReclamante,
          comunaServicio: detailClient?.COMUNA,
          cuentaContrato: state.confirmFormsCont.CuentaContrato,
          depto: state.confirmFormsCont.blockOrDptoReclamante,
          deptoServicio: state.confirmFormsCont.Dpto,
          descripcion: state.confirmFormsCont.Observacion,
          empresa: codigo_empresa,
          instalacion: state.confirmFormsCont.Instalacion,
          mail: state.confirmFormsCont.EmailReclamante,
          motivo: state.confirmFormsCont.CdgTipoReclamo,
          nombre: state.confirmFormsCont.NombReclamante,
          numero: state.confirmFormsCont.NroCalleReclamante,
          numeroServicio: `${detailClient?.NUMERO_CASA?detailClient?.NUMERO_CASA:""} ${detailClient?.PISO?detailClient?.PISO:""}`,
          rut: state.confirmFormsCont.RUTReclamante,
          signedIn: getSignedIdStatus(),
          solicitud: true,
          telefono: state.confirmFormsCont.TelefReclamante,
          tipo: "T",
          url: url,
        }
        dispatch({
          payload: jsonReclamo,
          type: ACTIONS.SET_FORMCONT,
        });
      }
    }
  }, [state.confirmFormsCont])

  React.useEffect(() => {
    if (confirm && state.confirmFormsCont) {
      setConfirm(false);
      setLoading(true);
      let jsonReclamo = {
        apellido1: state.confirmFormsCont.lastName,
        apellido2: state.confirmFormsCont.motherLastName,
        calle: state.confirmFormsCont.CalleReclamante,
        calleServicio: detailClient?.CALLE,
        canal: getPageLayoutType() ? "ZOV" : "URL",
        comuna: state.confirmFormsCont.ComunaReclamante,
        comunaServicio: detailClient?.COMUNA,
        cuentaContrato: state.confirmFormsCont.CuentaContrato,
        depto: state.confirmFormsCont.blockOrDptoReclamante,
        deptoServicio: state.confirmFormsCont.Dpto,
        descripcion: state.confirmFormsCont.Observacion,
        empresa: codigo_empresa,
        instalacion: state.confirmFormsCont.Instalacion,
        mail: state.confirmFormsCont.EmailReclamante,
        motivo: state.confirmFormsCont.CdgTipoReclamo,
        nombre: state.confirmFormsCont.NombReclamante,
        numero: state.confirmFormsCont.NroCalleReclamante,
        numeroServicio: `${detailClient?.NUMERO_CASA?detailClient?.NUMERO_CASA:""} ${detailClient?.PISO?detailClient?.PISO:""}`,
        rut: state.confirmFormsCont.RUTReclamante,
        signedIn: getSignedIdStatus(),
        solicitud: true,
        telefono: state.confirmFormsCont.TelefReclamante,
        tipo: "T",
        url: url,
      }
      dispatch({
        payload: jsonReclamo,
        type: ACTIONS.SET_FORMCONT,
      });
    }
  }, [confirm])

  React.useEffect(() => {
    if (state.responseFormCont) {
      if (state.responseFormCont?.code === 0
        || state.responseFormCont?.code === DUPLICATE_CLAIM_RESPONSE_CODE) {
        setLoading(false);
        setVisibleModalError(true);
        setDetailClient([]);
        setError(null);
      } else if (state.responseFormCont?.code !== 0 || state.responseFormCont?.status) {
        setError(state.responseFormCont?.mensaje ? state.responseFormCont?.mensaje : textFetchError)
        setLoading(false);
        setVisibleModalError(true);
      }
    }
  }, [state.responseFormCont]);

  return (
    <div id="content-forms-reclamo" className="bg-white rounded mt-4">
      <CGE.Panel
        title={`${tituloSolicitud} ${getPageLayoutType() ? "Oficina Virtual" : ""}`}
      >
        {valueExist &&
          <FormsGeneric
            props={props}
            tag="SO"
            setInputIdClient={setInputIdClient}
            setForm={setJsonForm}
            state={state}
            setNumberFirst={
              detailClient ? detailClient?.PRIMER_NOMBRE_PERSONA : ""
            }
            setNumberSecond={
              detailClient ? detailClient?.SEGUNDO_NOMBRE_PERSONA : ""
            }
            setNumberLast={
              detailClient ? detailClient?.APELLIDO_PERSONA : ""
            }
            setComuna={detailClient ? detailClient?.COMUNA : ""}
            setCalle={detailClient ? detailClient?.CALLE : ""}
            setNroCalle={detailClient ? detailClient?.NUMERO_CASA : ""}
            setDpto={detailClient ? detailClient?.SUPLEMENTO : ""}
            setPiso={detailClient ? detailClient?.PISO : ""}
            setRut={detailClient ? detailClient?.RUT : ""}
            setInstalacion={detailClient ? detailClient?.INSTALACION : ""}
            setInstalacionComercial={
              detailClient ? detailClient?.INTERLOCUTOR_COMERCIAL : ""
            }
            detailClient={detailClient}
            setDetailClient={setDetailClient}
            sociedad={codigo_empresa}
            error={error}
            visibleModalError={visibleModalError}
            optionsInteraction={optionsInteraction}
            allComunas={allComunas}
            solicitud={true}
            valueExist={valueExist}
          />
        }
        
        {(loading || !valueExist) && <Loading />}
        {visibleModalError && (
          <AlertModal
            titleModal={error
              ? "Advertencia"
              : state.responseFormCont?.code === DUPLICATE_CLAIM_RESPONSE_CODE
                ? "Información"
                : "Confirmación"}
            msgModal={error ? error : state.responseFormCont?.mensaje}
            observer={observer}
            onClose={() => {
              onClose()
              window.scroll({
                top: 0
              });
            }}
            status={
              state.responseFormCont?.code === 0
                ? "success"
                : state.responseFormCont?.code === DUPLICATE_CLAIM_RESPONSE_CODE
                  ? "info"
                  : "warning"
            }
          />
        )}
        {visibleModalConfirm && (
          <AlertModal
            titleModal="¡Advertencia!"
            msgModal={msgModalConfirm}
            observer={observer}
            onClose={() => {
              setMsgModalConfirm(null);
              setMsgModalCost(null);
              onClose();
              dispatch({
                payload: null,
                type: ACTIONS.SET_CONFIRM_FORMCONT,
              });
            }}
            status="warning"
            funcClick={() => {
              !handleSecondModal && setConfirm(true);
              setVisibleModalConfirm(false);
            }}
            confirm={true}
          />
        )}
        {visibleModalCost && !visibleModalConfirm && (
          <AlertModal
            titleModal="¡Advertencia!"
            msgModal={msgModalCost}
            observer={observer}
            onClose={() => {
              setMsgModalConfirm(null);
              setMsgModalCost(null);
              onClose();
              dispatch({
                payload: null,
                type: ACTIONS.SET_CONFIRM_FORMCONT,
              });
            }}
            status="warning"
            funcClick={() => {
              setHandleSecondModal(false);
              setConfirm(true);
              onClose();
            }}
            confirm={true}
          />
        )}

      </CGE.Panel>
    </div>
  );
};
const IngressoReclamoControllerWithProvider = ({
  tag,
  textFetchError,
  textLoadingBoleta,
  textFetchNoId,
  textAlertExcel,
  textAlertFilledField,
  setInputIdClient,
  setForm,
  titleReclamo,
  codigo_empresa,
  url,
  CTI,
  solicitud,
  tituloSolicitud,
  msgVerification,
  msgCost,
  props
}) => (
  <IngressoRectAndSolicitContextProvider>
    <IngressoReclamoController
      tag={tag}
      textFetchError={textFetchError}
      textLoadingBoleta={textLoadingBoleta}
      textFetchNoId={textFetchNoId}
      textAlertExcel={textAlertExcel}
      textAlertFilledField={textAlertFilledField}
      setInputIdClient={setInputIdClient}
      setForm={setForm}
      titleReclamo={titleReclamo}
      codigo_empresa={codigo_empresa}
      url={url}
      CTI={CTI}
      solicitud={solicitud}
      tituloSolicitud={tituloSolicitud}
      msgVerification={msgVerification}
      msgCost={msgCost}
      props={props}
    />
  </IngressoRectAndSolicitContextProvider>
);
export default IngressoReclamoControllerWithProvider;
